import { useParams } from 'react-router-dom'
import { skipToken } from '@reduxjs/toolkit/query/react'
import moment from 'moment'
import { useGetLabDeviceHistoryQuery } from 'store/services/devices'
import Link from '../../atoms/Link'
import routes from '../constants/routes'

const EVENT_BADGE_CLASS: Record<string, string> = {
    'Assigned to Order': 'badge-success',
    'Removed from Order': 'badge-warning',
    'Device Created': 'badge-primary',
    'Device Updated': 'badge-info',
    'Device Deleted': 'badge-danger',
    // TES-3191: shelf life and accessories
    'Retired': 'badge-dark',
    'First Check-Out Date Set': 'badge-info',
    'Accessory Assigned': 'badge-primary',
    'Accessory Replaced': 'badge-primary',
    'Accessory Serial Corrected': 'badge-info',
}

const DeviceHistory = () => {
    const { id } = useParams()
    const { data: history, isLoading } = useGetLabDeviceHistoryQuery(id ? Number(id) : skipToken)

    if (!id) return null

    if (isLoading) {
        return (
            <div className="col-12 mt-4">
                <h5 className="card-title mb-3">Event History</h5>
                <div className="text-center text-muted py-3">Loading history...</div>
            </div>
        )
    }

    if (!history || history.length === 0) {
        return (
            <div className="col-12 mt-4">
                <h5 className="card-title mb-3">Event History</h5>
                <div className="text-center text-muted py-3">No history available</div>
            </div>
        )
    }

    return (
        <div className="col-12 mt-4">
            <h5 className="card-title mb-3">Event History</h5>
            <div className="table-responsive" style={{ maxHeight: '600px', overflowY: 'auto' }}>
                <table className="table table-sm table-bordered table-hover">
                    <thead className="thead-light" style={{ position: 'sticky', top: 0, zIndex: 1 }}>
                        <tr>
                            <th>Event</th>
                            <th>Date</th>
                            <th>Performed By</th>
                            <th>Order</th>
                        </tr>
                    </thead>
                    <tbody>
                        {history.map((entry, index) => {
                            const badgeClass = EVENT_BADGE_CLASS[entry.eventName] ?? 'badge-secondary'
                            const userName = entry.user
                                ? `${entry.user.firstName} ${entry.user.lastName}`.trim()
                                : entry.userId
                                    ? `User #${entry.userId}`
                                    : <span className="text-muted">System</span>

                            return (
                                <tr key={index}>
                                    <td>
                                        <span className={`badge ${badgeClass}`} style={{ fontSize: '12px', lineHeight: '16px' }}>
                                            {entry.eventName}
                                        </span>
                                        {entry.details && (
                                            <div className="text-muted small mt-1">{entry.details}</div>
                                        )}
                                    </td>
                                    <td className="text-nowrap">
                                        {moment(entry.timestamp).format('MM/DD/YYYY HH:mm')}
                                    </td>
                                    <td>
                                        {entry.user ? (
                                            <span title={entry.user.email}>{userName}</span>
                                        ) : (
                                            userName
                                        )}
                                    </td>
                                    <td>
                                        {entry.orderId ? (
                                            <Link
                                                to={`${routes.index}${routes.order.edit}${entry.orderId}`}
                                                className="badge badge-primary"
                                                label={`#${entry.orderId}`}
                                                style={{ fontSize: '12px', lineHeight: '16px' }}
                                            />
                                        ) : (
                                            <span className="text-muted">—</span>
                                        )}
                                    </td>
                                </tr>
                            )
                        })}
                    </tbody>
                </table>
            </div>
        </div>
    )
}

export default DeviceHistory
